module.exports = __webpack_public_path__ + "public/SiteIcons/question.svg?c9585deb";